<template>
	<div class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center" id="page-login">
		<div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
			<vx-card>
				<div slot="no-body" class="full-page-bg-color">
					<div class="vx-row no-gutter justify-center items-center">
						<div class="vx-col hidden lg:block lg:w-1/2">
							<img src="@/assets/images/pages/login.png" alt="login" class="mx-auto">
						</div>
						<div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
							<div class="p-8 login-tabs-container">
								<div class="vx-card__title mb-4">
									<h4 class="mb-4">Reset je wachtwoord</h4>
									<p>Vul hier je nieuwe wachtwoord in</p>
								</div>
								<div>
									<form>
										<vs-input
											type=""
											name="newpassword"
											ref="newpassword"
											icon-no-border
											icon="icon icon-lock"
											icon-pack="feather"
											label="Wachtwoord"
											v-model="resetData.newpassword"
											class="w-full"
											v-validate="'required|min:1|max:191'" />
										<span class="text-danger text-sm" v-show="errors.has('newpassword')">{{
												errors.first('newpassword')
											}}</span>
										<vs-input
											type=""
											name="confirmpassword"
											icon-no-border
											icon="icon icon-lock"
											icon-pack="feather"
											label="Wachtwoord Herhalen"
											v-model="resetData.confirmpassword"
											class="w-full mt-6"
											v-validate="'required|min:1|max:191|confirmed:newpassword'" />
										<span class="text-danger text-sm"
											  v-show="errors.has('confirmpassword')">{{ errors.first('confirmpassword') }}</span>
										<br>
										<vs-button type="relief" @click.native="validate()">Wachtwoord wijzigen</vs-button>
									</form>
								</div>
							</div>
						</div>
					</div>
				</div>
			</vx-card>
		</div>
	</div>
</template>

<script>
import {mapActions} from 'vuex';
import Vue from 'vue';
import VeeValidate from 'vee-validate'
import {Validator} from 'vee-validate';

Vue.use(VeeValidate);
const dict = {
	custom: {
		newpassword: {
			required: 'Voer alstublieft een nieuw wachtwoord in',
			min: 'Voer alstublieft een nieuw wachtwoord in',
			max: 'Het wachtwoord kan maximaal 191 tekens lang zijn',
		},
		confirmpassword: {
			required: 'Voer alstublieft het nieuwe wachtwoord opnieuw in',
			min: 'Voer alstublieft het nieuwe wachtwoord opnieuw in',
			max: 'Het wachtwoord kan maximaal 191 tekens lang zijn',
			confirmed: 'Dit wachtwoord moet het zelfde zijn als het nieuwe wachtwoord',
		},
	}
};
Validator.localize('en', dict);
export default {
	data() {
		return {
			resetData: {
				newpassword: '',
				confirmpassword: '',
				token: '',
			}
		}
	},
	methods: {
		...mapActions({
			resetPassword: 'userStore/resetUserPassword',
		}),
		validate() {
			this.$validator.validateAll().then(result => {
				if (result) {
					this.getParams();
				} else {
					this.errorNotification();
				}
			}).catch(error => {
				this.errorNotification();
			});
		},
		errorNotification() {
			this.$vs.notify({
				title: 'Error',
				text: 'Er is iets fout gegaan',
				color: 'danger'
			})
		},
		getParams() {
			this.resetData.token = this.$route.query.token;
			this.resetPassword(this.resetData).then(res => {
				this.$vs.notify({
					title: 'Gelukt!',
					text: 'Je wachtwoord zijn opgeslagen, je kan nu inloggen',
					color: 'success'
				})
				this.$router.push('login')
			}).catch(err => {
				this.errorNotification()
			})
		}
	}
}
</script>

<style lang="scss">
#page-login {
	.social-login-buttons {
		.bg-facebook {
			background-color: #1551b1
		}

		.bg-twitter {
			background-color: #00aaff
		}

		.bg-google {
			background-color: #4285F4
		}

		.bg-github {
			background-color: #333
		}
	}
}
</style>
